import { isExperimentEnabled } from '@wix/communities-blog-client-common';
import { EXPERIMENT_USE_FILESUSR_DOMAIN } from '@wix/communities-blog-experiments';
import { getMetaSiteId } from '../store/instance-values/instance-values-selectors';

export const getIframeSandboxDomain = (state) => {
  return isExperimentEnabled(state, EXPERIMENT_USE_FILESUSR_DOMAIN)
    ? `https://${getMetaSiteId(state)}.filesusr.com`
    : `https://${getMetaSiteId(state)}.usrfiles.com`;
};
